import { createContext, useContext, ReactNode } from "react";
import { useGluceraAuth } from "../hooks/useGluceraAuth";

const GluceraAuthContext = createContext<ReturnType<
  typeof useGluceraAuth
> | null>(null);

export const GluceraAuthProvider = ({ children }: { children: ReactNode }) => {
  const auth = useGluceraAuth();
  return (
    <GluceraAuthContext.Provider value={auth}>
      {children}
    </GluceraAuthContext.Provider>
  );
};

export const useGluceraAuthContext = () => {
  const context = useContext(GluceraAuthContext);
  if (!context) {
    throw new Error(
      "useGluceraAuthContext must be used within GluceraAuthProvider"
    );
  }
  return context;
};
